import { render, staticRenderFns } from "./GameWeeks.vue?vue&type=template&id=ef5e3320&"
import script from "./GameWeeks.vue?vue&type=script&lang=js&"
export * from "./GameWeeks.vue?vue&type=script&lang=js&"
import style0 from "./GameWeeks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports